import { FC } from "react";
import { hardwareRequirements } from "../../../data/crystalPageContent";
import styles from "./index.module.css";

const HardwareRequirements: FC = () => (
  <div className={styles["grid"]}>
    {hardwareRequirements.map((item) => (
      <div key={item.title} className={styles["item"]}>
        <img src={item.icon} alt="" className={styles["icon"]} loading="lazy" />
        <h3 className={styles["title"]}>{item.title}</h3>
        <div className={styles["desc"]}>
          {item.description.map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default HardwareRequirements;
